// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"f6ecc7c2","281":"c797461b","325":"01dedebf","342":"1f5b9e78","575":"35135bfe","576":"87224d22","612":"bfd310d6","949":"0e0992b7"}[chunkId] + ".chunk.js";
};